export default "__VITE_ASSET__B8b3PzBG__"